import { routerActions } from "connected-react-router";
import { locale } from "numeral";
import React, { Component, Suspense, useReducer, useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";

//import Layout from "./containers/Layaout.jsx"
//import HomePage from "./containers/HomePage.jsx";
//import LoginPage from  "./containers/Login/LoginPage.jsx"

import { SiteRutas } from "./request/RutasConfig.jsx";
import ModalSpinner from './components/UI/modalSpinner/modalSpinner.jsx';
//export const GlobalParamCont = React.createContext();

const initialState = {
    UsuarioId: { value: '' },
    Usuario: { value: '' },
    tmpPass: { value: '' },
    tmpUsuarioId: { value: '' },
    tmpUser: { value: '' },
    EmpresaId: { value: '5' },
    EmpresaNombre: { value: '' },
    Telefono: { value: '' },
    GenPaisModulo: { value: '' }
}

const reducerGlobal = (state, action) => {
    //console.log('reducerGlobalSate', state);
    //console.log('reducerGlobalAction', action);
    if (action.name.trim().length > 0) {
        const name = action.name;
        const value = action.value;
        state = Object.assign({}, state, { [name]: { value: value } });
        return state;
    } else {
        return initialState;
    }
}


function App() {
    //const [GlobalParam, dispatch] = useReducer(reducerGlobal, initialState);
    //const [cargando, serCargando] =useState(true);

    const Asientos = React.lazy(() => import("./containers/Asientos/Lista/listaAsientos.jsx"));
    const AsociarCentroCosto =React.lazy(()=>import("./containers/CatalogoCuentas/Mantenimiento/asociarCentroCosto.jsx"));
    const CambiarContrasena = React.lazy(() => import("./containers/CambiarContrasena/cambiarContrasena.jsx"));
    const CargaAsientoExcel = React.lazy(() => import("./containers/CargaAsientosExcel/cargaAsientoExcel.jsx"));
    const CatalogoCentroCosto =React.lazy(()=> import("./containers/CatalogoCentroCosto/catalogoCentroCosto.jsx"));
    const CatalogoCuentas = React.lazy(() => import("./containers/CatalogoCuentas/catalogoCuentas.jsx"));
    const CentrosCosto = React.lazy(() => import("./containers/CentroCosto/Lista/listaCentroCosto.jsx"));
    const CentrosUtilidad = React.lazy(()=> import("./containers/CentroUtilidad/Lista/listaCentroUtilidad.jsx"));
    const CierreAnual = React.lazy(() => import("./containers/CierreAnual/cierreAnual.jsx"));
    const CierreMensual = React.lazy(() => import("./containers/CierreMensual/cierreMensual.jsx"));
    const ConciliacionAuxiliares = React.lazy(() => import("./containers/ConciliacionAuxiliares/conciliacionAuxiliares.jsx"));
    const Corporacion = React.lazy(() => import("./containers/Corporacion/Lista/listaCorporaciones.jsx"));
    const DesbloquearAsiento = React.lazy(() => import("./containers/Asientos/Acciones/desbloquearAsiento.jsx"));
    const DetalleAsiento =React.lazy(()=>import("./containers/Asientos/Mantenimiento/DetalleAsiento.jsx"));
    const Empresa = React.lazy(() => import("./containers/Empresas/Lista/listaEmpresas.jsx")); 
    const EstadoAsiento = React.lazy(() => import("./containers/Asientos/Acciones/estadoAsiento.jsx"));
    const EtiquetasReportes =React.lazy(()=> import ("./containers/EtiquetasReportes/etiquetasReportes.jsx"));
    const HomePage = React.lazy(() => import("./containers/HomePage.jsx"));
    const ImportarCatalogo = React.lazy(()=> import("./containers/importarCatalogoCuentas/Lista/importarCatalogo.jsx"));    
    const ImportarExcel = React.lazy(() => import("./containers/Asientos/Acciones/importarDeExcel.jsx"));
    const InsertarMasivo = React.lazy(()=> import("./containers/CatalogoCuentas/Mantenimiento/insertarMasivo.jsx"));
    const ImportarTiposAsiento =React.lazy(()=> import("./containers/importarTipoAsientos/Lista/importarTiposAsiento.jsx"));
    const Layout = React.lazy(() => import("./containers/Layaout.jsx"));
    const LoginPage = React.lazy(() => import("./containers/Login/LoginPage.jsx"));
    const MantAsientos = React.lazy(() => import("./containers/Asientos/Mantenimiento/index.jsx"));
    const MantCatalogoCentroCosto =React.lazy(()=> import("./containers/CatalogoCentroCosto/Mantenimiento/mantCatalogoCentroCosto.jsx"));
    const MantCatalogoCuentas = React.lazy(() => import("./containers/CatalogoCuentas/Mantenimiento/mantCatalogoCuentas.jsx"));
    const MantCentrosCosto = React.lazy(() => import("./containers/CentroCosto/Mantenimiento/MantCentrosCostos.jsx"));
    const MantCentroUtilidad = React.lazy(()=>import("./containers/CentroUtilidad/Mantenimiento/mantCentroUtilidad.jsx"));
    const MantCorporaciones = React.lazy(() => import("./containers/Corporacion/Mantenimiento/mantCorporaciones.jsx"));
    const MantEmpresasInt  =React.lazy(()=> import("./containers/Empresas/Mantenimiento/mantEmpresas.jsx"))
    const MantPlantillas = React.lazy(() => import("./containers/Plantillas/Mantenimiento/MantPlantillas.jsx"));
    const MantPresupuesto = React.lazy(()=> import ("./containers/Presupuesto/Mantenimiento/index.jsx"));
    const MantSubTiposCuentas = React.lazy(() => import("./containers/SubtTposCuentas/Mantenimiento/mantSubTiposCuentas.jsx"));
    const MantTiposAsientos = React.lazy(() => import("./containers/TiposAsientos/Mantenimiento/mantTiposAsientos.jsx"));
    const Parametros =React.lazy(()=> import("./containers/Parametros/Mantenimiento/mantParametros.jsx"));
    const Plantillas = React.lazy(() => import("./containers/Plantillas/Lista/listaPlantillas.jsx"));
    const Reporte = React.lazy(() => import("./containers/reportes/index.jsx"));
    const SubTipoCuentas =React.lazy(()=> import ("./containers/SubtTposCuentas/Lista/listaSubTiposCuentas.jsx"));
    const TiposAsientos =React.lazy(()=> import ("./containers/TiposAsientos/Lista/listaTiposAsientos.jsx"));

    //   useEffect(() => {
    //       console.log('Se mete todas las veces APP');
    // }, [])

    return (
        <Suspense fallback={null}>
            {/*<GlobalParamCont.Provider value={{globalParam: GlobalParam, globalDispatch: dispatch}}>*/}
            <Switch>
                <Route
                    path={[
                        SiteRutas.Home,
                        SiteRutas.Asientos,
                        `${SiteRutas.AsociarCentroCosto}/:id/:padre`,
                        `${SiteRutas.CargaAsientoExcel}/:id`,
                        SiteRutas.CargaAsientoExcel,
                        SiteRutas.CatalogoCentroCosto,
                        SiteRutas.CatalogoCuentas,
                        SiteRutas.CentrosCosto,
                        SiteRutas.CentrosUtilidad,
                        SiteRutas.CierreAnual,
                        SiteRutas.CierreMensual,
                        SiteRutas.ConciliacionAuxiliares,
                        SiteRutas.Corporacion,
                        SiteRutas.DesbloquearAsiento,
                        `${SiteRutas.DetalleAsiento}/:id`,
                        SiteRutas.Empresa,
                        `${SiteRutas.EstadoAsiento}/:id`,
                        SiteRutas.EtiquetasReportes,
                        SiteRutas.ImportarCatalogo,
                        `${SiteRutas.ImportarExcel}/:id`,
                        SiteRutas.ImportarTiposAsiento,
                        SiteRutas.InsertarMasivo,
                        `${SiteRutas.MantAsientos}/:id/:idPlantilla`,
                        `${SiteRutas.MantCatalogoCuentas}/:idp/:idh/:idr`,
                        `${SiteRutas.MantCatalogoCentroCosto}/:idp/:idh/:idr`,
                        `${SiteRutas.MantCentrosCostos}/:id`,
                        `${SiteRutas.MantCentroUtilidad}/:id`,
                        `${SiteRutas.MantCorporaciones}/:id`,
                        `${SiteRutas.MantEmpresasInt}/:id`,
                        `${SiteRutas.MantPlantillas}/:id/`,
                        `${SiteRutas.MantSubTiposCuentas}/:id/`,
                        `${SiteRutas.MantTiposAsientos}/:id/`,
                        SiteRutas.Parametros,
                        SiteRutas.Plantillas,
                        SiteRutas.MantPresupuesto,
                        `${SiteRutas.Reporte}/:ReportId/:Sec`,
                        SiteRutas.TipoCuentas,
                        SiteRutas.TiposAsientos,
                    ]}
                >
                    <Layout >
                        <Switch>
                            <Route path={SiteRutas.Asientos} component={Asientos} />
                            <Route path={`${SiteRutas.AsociarCentroCosto}/:id/:padre`} component={AsociarCentroCosto} />
                            <Route path={`${SiteRutas.CargaAsientoExcel}/:id`} component={CargaAsientoExcel} />
                            <Route path={SiteRutas.CargaAsientoExcel} component={CargaAsientoExcel} />
                            <Route path={SiteRutas.CatalogoCentroCosto} component={CatalogoCentroCosto}/>
                            <Route path={SiteRutas.CatalogoCuentas} component={CatalogoCuentas}/>
                            <Route path={SiteRutas.CentrosCosto} component={CentrosCosto}/>
                            <Route path={SiteRutas.CentrosUtilidad} component={CentrosUtilidad}/>                            
                            <Route path={SiteRutas.CierreAnual} component={CierreAnual} />
                            <Route path={SiteRutas.CierreMensual} component={CierreMensual} />
                            <Route path={SiteRutas.ConciliacionAuxiliares} component={ConciliacionAuxiliares} />
                            <Route path={SiteRutas.Corporacion} component={Corporacion} />
                            <Route path={SiteRutas.DesbloquearAsiento} component={DesbloquearAsiento} />
                            <Route path={`${SiteRutas.DetalleAsiento}/:id`} component={DetalleAsiento} />
                            <Route path={SiteRutas.Empresa} component={Empresa} />
                            <Route path={`${SiteRutas.EstadoAsiento}/:id`} component={EstadoAsiento} />
                            <Route path={SiteRutas.EtiquetasReportes} component={EtiquetasReportes} />
                            <Route path={SiteRutas.Home} component={HomePage} />
                            <Route path={SiteRutas.ImportarCatalogo}  component={ImportarCatalogo} />
                            <Route path={`${SiteRutas.ImportarExcel}/:id`} component={ImportarExcel} />
                            <Route path={SiteRutas.ImportarTiposAsiento} component={ImportarTiposAsiento} />
                            <Route path={SiteRutas.InsertarMasivo}  component={InsertarMasivo} />
                            <Route path={`${SiteRutas.MantAsientos}/:id/:idPlantilla`} component={MantAsientos} />
                            <Route path={`${SiteRutas.MantCatalogoCentroCosto}/:idp/:idh/:idr`} component={MantCatalogoCentroCosto}/>
                            <Route path={`${SiteRutas.MantCatalogoCuentas}/:idp/:idh/:idr`} component={MantCatalogoCuentas}/>
                            <Route path={`${SiteRutas.MantCentrosCostos}/:id`} component={MantCentrosCosto} />
                            <Route path={`${SiteRutas.MantCentroUtilidad}/:id`} component={MantCentroUtilidad}/>
                            <Route path={`${SiteRutas.MantCorporaciones}/:id`} component={MantCorporaciones} />
                            <Route path={`${SiteRutas.MantEmpresasInt}/:id`} component={MantEmpresasInt} />                            
                            <Route path={`${SiteRutas.MantPlantillas}/:id`} component={MantPlantillas} />
                            <Route path={SiteRutas.MantPresupuesto} component={MantPresupuesto} />
                            <Route path={`${SiteRutas.MantSubTiposCuentas}/:id`} component={MantSubTiposCuentas} />
                            <Route path={`${SiteRutas.MantTiposAsientos}/:id`} component={MantTiposAsientos} />
                            <Route path={SiteRutas.Parametros} component={Parametros} />
                            <Route path={SiteRutas.Plantillas} component={Plantillas} />
                            <Route path={`${SiteRutas.Reporte}/:ReportId/:Sec`} component={Reporte} />
                            <Route path={SiteRutas.TipoCuentas} component={SubTipoCuentas} />
                            <Route path={SiteRutas.TiposAsientos} component={TiposAsientos} />
                            <Route component={HomePage} />
                        </Switch>
                        
                    </Layout>
                </Route>
                <Route
                    path={[
                        SiteRutas.Login,
                        SiteRutas.Base,
                        SiteRutas.CambiarContrasena
                    ]}
                >
                    <Switch>
                        <Route path={SiteRutas.Login} component={LoginPage} />
                        <Route
                            path={`${SiteRutas.CambiarContrasena}/:inicio`}
                            component={CambiarContrasena}
                        />
                        <Route component={LoginPage} />
                    </Switch>
                </Route>
            </Switch>
            {/*</GlobalParamCont.Provider>*/}
        </Suspense>

    );
}

export default App;
